import { FACILITY_DETAILS_QUERY } from '../data-access/facility-details-query'
import { BaseQuery } from './BaseQuery'
import {
  facilityDetails,
  facilityDetailsVariables
} from '../data-access/__generated__/types'

export class FacilityDetailsQuery extends BaseQuery<
  facilityDetails,
  facilityDetailsVariables
> {
  query = FACILITY_DETAILS_QUERY
}
